export default function consentCssScript() {

  return `

    #cmp-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 1200;
    }
    @media (min-width: 960px) {
      #cmp-banner {
        bottom: 20px;
        left: 20px;
      }
    }
    #cmp-banner:empty {
      display: none;
    }

  `

}